import { PAYMENT_STATUS } from "@/core/enums/PAYMENT_STATUS";
import { RECEIPT_STATUS } from "@/core/enums/RECEIPT_STATUS";

export const PAYMENTS_API_PATH = {
  GET: "v1/payments/",
  GET_BY_ID: "v1/payments/{0}",
  POST: "v1/payments/",
  GET_PAYMENTS_BY_DATE_RANGE: "v1/insights/payments-by-sector/",
  GET_PAYMENT_LIST: "v2/payments/methods/?organization_id=",
  CONTENT_UPLOAD: "v1/content/upload/{0}/",
  UPDATE_BANK_TRANSFER: "v1/payments/bank-transfer/{0}/",
  GET_SYSTEM_BANKS: "v1/payments/system-banks/",
};
export const payGuideUrl =
  "https://storage.googleapis.com/proxima-gcp-store/logos/Core/PaymentGuide.pdf";

export const PAYMENT_STATUS_MAPPING = {
  [PAYMENT_STATUS.PENDING]: "info",
  [PAYMENT_STATUS.INITIATED]: "warning",
  [PAYMENT_STATUS.SUCCESS]: "success",
  [PAYMENT_STATUS.CANCELED]: "error",
  [PAYMENT_STATUS.ERROR]: "error",
  [PAYMENT_STATUS.DECLINED]: "error",
  [PAYMENT_STATUS.EXPIRED]: "error",
};

export const RECEIPT_STATUS_MAPPING = {
  [RECEIPT_STATUS.PAYMENT_PENDING]: "warning",
  [RECEIPT_STATUS.PENDING]: "info",
  [RECEIPT_STATUS.FAILED]: "error",
  [RECEIPT_STATUS.POSTED]: "success",
};
